
import { ResultData } from "@nt-portal/common-sdk";

import { AIPayloadItem, DbInuseResult, TCMMasterGroupField, TCMMasterGroupFieldService } from "@nt-portal/tcm-sdk";
import { BaseClientService } from "../../base-client.service";
import { ControllerOptions, DataController } from "../../../../types";
import { ValidateResult } from "@nt-portal/common-sdk";
import { createTCMMasterGroup } from "./master-group.service";

export interface TCMMasterGroupFieldOptions extends ControllerOptions<TCMMasterGroupField> {
    fieldType?: string;
}

export interface DisplayTypes {
    [key: string]: any;
}

export const dataTypes = ['string', 'integer', 'float', 'boolean', 'date', 'currency']
export const displayTypes: DisplayTypes =
{
    'string': ["string"],
    'integer': ["integer"],
    'float': ["float", 'percentage', 'currency'],
    'boolean': ["boolean"],
    'date': ["date"]
}



export const createTCMMasterGroupField = (inItem: Partial<TCMMasterGroupField>) => {
    let item: TCMMasterGroupField = {
        excelHeading: "",
        fieldType: "master-group",
        required: false,
        name: "",
        dataType: "",
        displayType: "",
        sheetFields: [],

        createdBy: "",
        group: createTCMMasterGroup({}),
    }
    return { ...item, ...inItem }
}

export class ClientTCMMasterGroupFieldService extends BaseClientService implements DataController<TCMMasterGroupField> {

    private _service: TCMMasterGroupFieldService;


    constructor() {
        super();
        this._service = new TCMMasterGroupFieldService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMMasterGroupFieldOptions): Promise<ResultData<TCMMasterGroupField>> {
        if (this.params.groupId)
            return await this._service.get(this.buildFetchParams(options), this.token, options.filter, options.fieldType);
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }

    public async import(options: TCMMasterGroupFieldOptions): Promise<any> {
        if (options.file && this.params.groupId)
            return await this._service.importExcel(options.file, this.token);
    }

    public async export(options: TCMMasterGroupFieldOptions): Promise<ArrayBuffer | null> {

        if (this.params.groupId)
            return await this._service.export(this.token, this.buildLookupFetchParams(options), options.filter);
        return null;

    }

    public async getLookup(options: TCMMasterGroupFieldOptions): Promise<ResultData<TCMMasterGroupField>> {
        if (this.params.groupId) {
            let fetchParams = this.buildLookupFetchParams(options);
            let data = await this._service.get(fetchParams, this.token, options.filter, options.fieldType);
            return data;
        }
        return {
            data: [],
            limit: -1,
            skip: 0,
            total: 0
        }
    }

    public async getById(options: TCMMasterGroupFieldOptions): Promise<TCMMasterGroupField | null> {
        if (options.id && this.params.groupId) {
            let item = await this._service.getById(options.id, this.token);
            return item;
        }
        return null;
    }
    public async delete(options: TCMMasterGroupFieldOptions): Promise<any> {
        if (options.id && this.params.groupId)
            await this._service.delete(options.id, this.token);
    }
    public async update(options: TCMMasterGroupFieldOptions): Promise<TCMMasterGroupField | TCMMasterGroupField[] | null> {
        if (options.item && options.item.id && this.params.groupId)
            return await this._service.update(options.item.id, options.item, this.token)
        return null;
    }
    public async add(options: TCMMasterGroupFieldOptions): Promise<TCMMasterGroupField | TCMMasterGroupField[] | null> {
        if (options.item && this.params.groupId)
            return await this._service.add(options.item, this.token)
        return null;
    }

    public async aiGenerate(payload: AIPayloadItem[]): Promise<TCMMasterGroupField[]> {
        if (payload && this.params.groupId)
            return await this._service.aiGenerate(this.token, payload)
        return [];
    }

    public async validateName(name: string, id?: string, groupId?: string): Promise<ValidateResult | null> {
        if (this.params.groupId)
            return await this._service.validateName(name, this.token, id, "", { contract: groupId })
        return null;
    }

    public async inUse(options: TCMMasterGroupFieldOptions): Promise<DbInuseResult[]> {
        if (options.id) {
            return await this._service.inUse(options.id, this.token);
        } else {
            throw new Error("ID is required for inUse check");
        }
    }


}
